import { formatDistanceToNow, format, Locale } from 'date-fns';
import { es, enUS, ptBR, fr, it } from 'date-fns/locale';
import { i18n } from '../translate/i18n';

// Map i18next language codes to date-fns locales
const localeMap: Record<string, Locale> = {
  es: es,
  en: enUS,
  'pt-BR': ptBR,
  pt: ptBR,
  fr: fr,
  it: it
};

// Get current date-fns locale based on i18n language
export const getDateFnsLocale = (): Locale => {
  const currentLang = i18n.language || 'pt-BR';
  return localeMap[currentLang] || ptBR;
};

export const formatDate = (date: string | Date): string => {
  try {
    return format(new Date(date), "dd MMM yyyy, HH:mm", {
      locale: getDateFnsLocale()
    });
  } catch {
    return i18n.t?.('common.error') || 'Invalid date';
  }
};

export const formatTimeAgo = (date: string | Date): string => {
  try {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: getDateFnsLocale()
    });
  } catch {
    return i18n.t?.('timeAgo.justNow') || 'Just now';
  }
};

export const formatDateShort = (date: string | Date): string => {
  try {
    return format(new Date(date), "dd/MM/yyyy", {
      locale: getDateFnsLocale()
    });
  } catch {
    return '--/--/----';
  }
};
